<template>
    <section :id="`element-${settings.id}`" class="elle-team padd-v" :style="{ backgroundColor: settings?.color }">
        <UiHeadlineContent
            :settings="{
                label: settings?.label,
                headline: settings?.headline,
                content: settings?.description
            }"
        />
        <LoopsTeam v-if="!!settings?.team.length" :persons="settings?.team" />
    </section>
</template>

<script setup lang="ts">
defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
